import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

export default ({ country, config }) => {
  const isFrontAppsRouteOpenedInCountry =
    config.FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_ABOUT_US.includes(country)

  return [
    {
      path: 'about-us',
      name: ROUTES.ABOUT_US,
      component: () => dynamicImport(import('./AboutUs.vue')),
      meta: { disableClientSideNavigation: isFrontAppsRouteOpenedInCountry },
    },
  ]
}
